// externals
import { RSAA } from 'redux-api-middleware';

// types
import type { RSAACallAction, RSAACallRequest } from '@makemydeal/dr-react-18-wrappers';
import type { VehicleDetailsParams } from '@makemydeal/dr-sales-checkin-types/types/VehicleDetails';

// actions
import { FETCH_VEHICLE_DETAILS_REQUEST, FETCH_VEHICLE_DETAILS_SUCCESS, FETCH_VEHICLE_DETAILS_FAILURE } from './actions';

// utils
import { buildQueryParams } from '../utils';

export const fetchVehicleDetails = (params: VehicleDetailsParams, bffUrl: string): RSAACallAction => {
    const queryParams = buildQueryParams(params);
    const endpoint = `${bffUrl}?${queryParams.toString()}`;

    return {
        [RSAA]: {
            endpoint,
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
            types: [FETCH_VEHICLE_DETAILS_REQUEST, FETCH_VEHICLE_DETAILS_SUCCESS, FETCH_VEHICLE_DETAILS_FAILURE]
        } satisfies RSAACallRequest
    } as RSAACallAction;
};
